import { AppClientConfigurationService } from '@sdbn/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class YardPropertiesService {

  constructor(
    private appClientConfigurationService: AppClientConfigurationService
  ) { }



  /* weighing properties */

  public isWeighingEnabled () :boolean {

    return this.appClientConfigurationService.isPropertyTrue('tmc-yard.weighing.enabled');
  }


  public getDialogScaleKey () :string {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.weighing.dialog.scaleKey');

    if (propertyValue.length != 0) {
      return propertyValue;
    }
    return null;
  }



  public isWeighingEntranceEnabled () :boolean {

    return this.appClientConfigurationService.isPropertyTrue('tmc-yard.weighing.entrance.enabled');
  }



  public getEntranceMinLength () :number {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.weighing.entrance.minLength');

    if (propertyValue != null) {
      try {
        const value = +propertyValue;
        if (value >= 0) {
          return value;
        }
      } catch (e) {

      }
    }
    return 0;
  }


  public getEntranceType () :string {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.weighing.entrance.type');

    if (propertyValue.length != 0) {
      return propertyValue;
    }
    return null;
  }


  public getEntranceScaleKey () :string {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.weighing.entrance.scaleKey');

    if (propertyValue.length != 0) {
      return propertyValue;
    }
    return null;
  }




  public isWeighingLeaveEnabled () :boolean {

    return this.appClientConfigurationService.isPropertyTrue('tmc-yard.weighing.leave.enabled');
  }




  public getLeaveMinLength () :number {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.weighing.leave.minLength');

    if (propertyValue != null) {
      try {
        const value = +propertyValue;
        if (value >= 0) {
          return value;
        }
      } catch (e) {

      }
    }
    return 0;
  }



  public getLeaveType () :string {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.weighing.leave.type');

    if (propertyValue.length != 0) {
      return propertyValue;
    }
    return null;
  }



  public getLeaveScaleKey () :string {
    const propertyValue = this.appClientConfigurationService.getPropertyValue('tmc-yard.weighing.leave.scaleKey');

    if (propertyValue.length != 0) {
      return propertyValue;
    }
    return null;
  }







  /* supplementary equipment properties */


  public isHideInRegisterTransportEnabled () :boolean {

    return this.appClientConfigurationService.isPropertyTrue('tmc-yard.supplementaryequipment.hide-in-register-transport');
  }



  public isShowNoHandoutEnabled () :boolean {

    return this.appClientConfigurationService.isPropertyTrue('tmc-yard.supplementaryequipment.show-no-handout');
  }


}
